import httpService from '@/services/httpService'

export const types = {
  SET_SERPS: 'viewHistory/SET_SERPS',
  SET_SETTINGS: 'viewHistory/SET_SETTINGS'
}

const state = {
  serps: [],
  settings: {
    locations: []
  }
}

const mutations = {
  [types.SET_SERPS]: function (state, serps) {
    state.serps = serps
  },
  [types.SET_SETTINGS]: function (state, settings) {
    state.settings = settings
  }
}

const actions = {
  getSerpData: async function ({ commit }, { serpId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/serp-tracker/view-history/${serpId}`, { params })
    if (!response || !response.data) {
      return []
    }
    commit(types.SET_SERPS, response.data)
    return response.data
  },
  getSerpSettings: async function ({ commit }, { serpId }) {
    const response = await httpService.get(`/serp-tracker/view-history/settings/${serpId}`)
    if (!response || !response.data) {
      return []
    }
    commit(types.SET_SETTINGS, response.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
